module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/3_96e7a2afcd1a340c7e25b0c4215a7aeb.jpg";